import { createSlice } from '@reduxjs/toolkit';

// ---------------------------------------------------------------------------
// State
// Cross-component, app-wide UI state that doesn't belong to any one feature
// (e.g. the command palette today; other global toggles/modals can join it).
// ---------------------------------------------------------------------------

interface UiState {
  isCommandPaletteOpen: boolean;
}

const initialState: UiState = {
  isCommandPaletteOpen: false,
};

// ---------------------------------------------------------------------------
// Slice
// ---------------------------------------------------------------------------

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openCommandPalette: (state) => {
      state.isCommandPaletteOpen = true;
    },
    closeCommandPalette: (state) => {
      state.isCommandPaletteOpen = false;
    },
    toggleCommandPalette: (state) => {
      state.isCommandPaletteOpen = !state.isCommandPaletteOpen;
    },
  },
});

export const { openCommandPalette, closeCommandPalette, toggleCommandPalette } = uiSlice.actions;

// ---------------------------------------------------------------------------
// Selectors
// ---------------------------------------------------------------------------

type StateWithUi = { ui: UiState };

export const selectIsCommandPaletteOpen = (state: StateWithUi) => state.ui.isCommandPaletteOpen;
